import React from 'react';
import { Menu } from "semantic-ui-react";
import { NavLink, Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ShowGroupMembers from "../common/ShowGroupMembers";
import AddMember from './AddMember';
const StyledNavLink = styled(NavLink) `
  &&&&:hover {
   background-color: rgba(0,0,0,.03)
  }

  &&&&.active {
    background-color: rgba(0,0,0,.05);
  }
`;
const CompaniesMembersPane = ({ isAdmin }) => {
    const { t } = useTranslation('common');
    const { path, url } = useRouteMatch();
    return React.createElement("div", null,
        React.createElement(Menu, { stackable: true },
            React.createElement(Menu.Item, { as: StyledNavLink, to: `${url}`, exact: true }, t('groupsCommon.membersInfo')),
            isAdmin && React.createElement(Menu.Item, { as: StyledNavLink, to: `${url}/add` }, t('companies.addCompanyMembers'))),
        React.createElement(Switch, null,
            React.createElement(Route, { exact: true, path: `${path}` },
                React.createElement(ShowGroupMembers, { isAdmin: isAdmin })),
            isAdmin && React.createElement(Route, { exact: true, path: `${path}/add` },
                React.createElement(AddMember, null)),
            React.createElement(Redirect, { from: `${path}/*`, to: `${path}` })));
};
export default CompaniesMembersPane;
